export default {
  // Controls whether debug messages display in the console
  quiet: IS_QUIET_MODE,
}
